<template>
    <div />
</template>

<script>
import { getLock, getOptions, login } from './Login/functions'

export default {
    name: 'login',
    beforeMount() {
        Promise.all([getLock(), getOptions()]).then(login)
    },
}
</script>
